import { connect } from 'react-redux';

// Selectors
import { getBounds, getTilesUrl, getComparingTilesUrl, getViewport } from 'components/emissions-demo/selectors';

// Components
import CompareMap from 'components/map';

const mapStateToProps = state => ({
  bounds: getBounds(state),
  tilesUrl: getTilesUrl(state),
  comparingTilesUrl: getComparingTilesUrl(state),
  viewport: getViewport(state)
});

export default connect(mapStateToProps)(CompareMap);



// WEBPACK FOOTER //
// ./src/components/emissions-demo/components/compare-map/index.js